import { To, useNavigate } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'

import filesStore from 'modules/documents/components/Documents/store'
import FoldersList from 'modules/documents/components/DocumentsAndFolders/FoldersList'
import DocumentsDataTable from 'modules/documents/components/DocumentsDatatable'
import { Folder } from 'modules/documents/hooks/useGetFolders'
import { SPACES } from 'modules/documents/lib/constants'

interface Props {
  folder: Folder
  employeeId?: number
  legalEntityCountry?: string
  canUploadDocument: boolean
  backActionUrl: string
  selectedFolder: Folder | undefined | null
  onFolderSelected: (folder: Folder) => void
  parentRoute: To
  isLoading?: boolean
}

const FolderType = ({
  folder,
  employeeId,
  legalEntityCountry,
  canUploadDocument,
  parentRoute,
  backActionUrl,
  selectedFolder,
  onFolderSelected,
  isLoading = false,
}: Props) => {
  const { employee: currentEmployee } = useCurrentSession()
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const readonly = folder.showOnly || !canUploadDocument
  const isMyDocuments = currentEmployee?.id === employeeId
  const employeeIdToUse = employeeId || currentEmployee.id

  const onDrop = (files: File[]) => {
    if (!canUploadDocument) return null

    onFolderSelected(folder)

    filesStore.setFiles(files)
    return navigate(backActionUrl)
  }

  const onUpload = () => {
    onFolderSelected(folder)
    navigate(newUrl)
  }

  const newUrl = isMyDocuments
    ? navigation.documents.folderId.new.fullPath({ folderId: folder.id })
    : navigation.employees.id.documents.folderId.new.fullPath({
        id: employeeIdToUse,
        folderId: folder.id,
      })

  const onNavigationClick = (documentId: number) => {
    const documentUrl = isMyDocuments
      ? navigation.documents.folderId.documentId.fullPath({
          folderId: folder.id,
          document_id: documentId,
        })
      : navigation.employees.id.documents.folderId.documentId.fullPath({
          id: employeeIdToUse,
          folderId: folder.id,
          document_id: documentId,
        })

    navigate(documentUrl)
  }

  return (
    <>
      <Box paddingY="s16">
        <FoldersList
          parentFolderId={folder.id}
          employeeId={employeeIdToUse}
          legalEntityCountry={legalEntityCountry}
          space={SPACES.EMPLOYEE_MY_DOCUMENTS}
          readonly={readonly}
          onFolderSelected={onFolderSelected}
        />
        <Box paddingTop="s8">
          <DocumentsDataTable
            employeeId={employeeIdToUse}
            folder={folder}
            initialFolder={selectedFolder}
            parentRoute={parentRoute}
            onDrop={onDrop}
            readonly={readonly}
            onNavigationClick={onNavigationClick}
            onUpload={onUpload}
            isLoading={isLoading}
          />
        </Box>
      </Box>
    </>
  )
}

export default FolderType
